import { useState } from 'react';
import { SecondaryButton } from 'ui/button';
import { Snippet } from 'ui/icons/action/Snippet';
import { InsertSnippetModal } from 'modules/snippets/components/modals/InsertSnippetModal';
import { useTranslation } from '../../../hooks/useTranslation';

type SnippetPickerButtonProps = {
  onSelectContent: (content: string) => void;
};

export const SnippetPickerButton = ({ onSelectContent }: SnippetPickerButtonProps) => {
  const { t } = useTranslation();
  const [isShowingSnippetPicker, setIsShowingSnippetPicker] = useState(false);

  const onClose = () => {
    setIsShowingSnippetPicker(false);
  };

  const onClick = () => {
    setIsShowingSnippetPicker(true);
  };

  const onSelect = (snippetReference: string) => {
    setIsShowingSnippetPicker(false);
    onSelectContent(snippetReference);
  };

  return (
    <>
      {isShowingSnippetPicker && (
        <InsertSnippetModal
          closeModal={onClose}
          onInsertSnippet={onSelect}
          data-portal-id="snippet-picker-modal"
        />
      )}
      <SecondaryButton onClick={onClick} data-test="snippet-picker-button">
        <Snippet isColorInherited />
        {t('contentPicker.snippet')}
      </SecondaryButton>
    </>
  );
};
